<script setup>
import { inject } from 'vue'
const { global, screen } = inject('Shared')
const props = defineProps({ visible: Boolean })
const emit = defineEmits(['update:visible'])
</script>

<template lang="pug">
.closeBtn(@click="$emit('update:visible', false)" :style="`background: ${screen.gt.sm ? global.graphicElementColor : 'transparent' }`")
  svg.gt-sm(width='11' height='11' viewBox='0 0 11 11' fill='none' xmlns='http://www.w3.org/2000/svg')
    path(fill-rule='evenodd' clip-rule='evenodd' d='M2.31893 0.196697L0.197607 2.31802L3.37958 5.5L0.197602 8.68198L2.31892 10.8033L5.50091 7.62132L8.68289 10.8033L10.8042 8.68198L7.62223 5.5L10.8042 2.31802L8.68289 0.196695L5.50091 3.37867L2.31893 0.196697Z' fill='#F6F7FA')
  svg.lt-md(width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg')
    path(d='M14.1265 1.42309L12.7038 0L7.06325 5.64191L1.42274 0L0 1.42309L5.64051 7.065L0 12.7069L1.42274 14.13L7.06325 8.48809L12.7038 14.13L14.1265 12.7069L8.48599 7.065L14.1265 1.42309Z' fill='#626C85')
</template>

<style scoped lang="sass">
.closeBtn
  padding: 6px 6px 0 0
  position: sticky
  z-index: 100
  cursor: pointer
  display: flex
  justify-content: flex-end
  @media screen and (min-width: 1024px)
    padding: 6px
    top: -12.5px
    right: 30px
    display: flex
    position: absolute
    justify-content: center
    align-items: center
    width: 25px
    height: 25px
    box-shadow: 0px 4px 16px rgba(98, 108, 133, 0.16)
    border-radius: 6px
  @media screen and (max-width: 1023px)
    top: 10px
    right: 10px
    position: absolute
</style>
